"use client"

import { toast } from "sonner"
import { ShareIcon } from "@/components/core/icons/Share"

export const ShareButton = ({ shareLink }: { shareLink: string }) => {
  const handleCopy = (link: string) => {
    navigator.clipboard.writeText(link)
    toast.success("Link copied to clipboard")
  }

  return (
    <button
      className="flex gap-2 items-center font-medium text-grey-600 hover:text-white transition-all duration-200"
      onClick={() => handleCopy(shareLink)}
    >
      <ShareIcon />
      Share
    </button>
  )
}
